import firebase from 'firebase';
// import '@firebase/messaging';
export const initializeFirebase = () => {
  firebase.initializeApp({
    apiKey: "AIzaSyAIgcf9qDXvSD8OEXASBG69V6lTCBix4BY",
    authDomain: "interbrucke-22acf.firebaseapp.com",
    projectId: "interbrucke-22acf",
    storageBucket: "interbrucke-22acf.appspot.com",
    messagingSenderId: "996409697294",
    appId: "1:996409697294:web:33b9428d3525ae57e2085f",
    measurementId: "G-0MP8BQ50LL"
  });
}

export const askForPermissionToReceiveNotifications = async () => {
    try {
      const messaging = firebase.messaging();
      await messaging.requestPermission();
      const token = await messaging.getToken();
      console.log('Your token is:', token);
      
      return token;
    } catch (error) {
      console.error(error);
    }
  }


// WEBPACK FOOTER //
// ./src/push-notification.js